
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const PauseCircle20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M9 8a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0V8Zm2.5-.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V8a.5.5 0 0 0-.5-.5ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
            fill="currentColor"
        />
    </svg>
}
